// Ambiente dev publicado em https://dev.flowtify.com.br (build com --configuration dev).
export const environment = {
  production: false,
  client_id: '2137613306241255',
  redirect_uri: 'https://dev.flowtify.com.br/login/',
  apiUrl: 'https://api-dev.flowtify.com.br/api',
  zebraUrl: 'http://localhost:3000',
  labelaryUrl: 'http://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/>label.pdf',
  ignoreSelfSignedCert: true,
  flagsmithEnvironmentId: 'ZRimdsUw9SCq3dNy58L4WU',
  // Rótulo exibido no topo da tela para identificar o ambiente; vazio não exibe nada.
  environmentTag: 'DEV',
  // Tela de stub do Mercado Livre (/ml-stub). Só em desenvolvimento; a API também precisa estar com o stub ativo.
  mlStub: true,
  // Ambiente informado ao serviço local de impressão (GET /printers?env=...). Com 'dev' a
  // listagem inclui a fake-printer, que salva a etiqueta em PDF e abre na tela em vez de imprimir.
  printerEnv: 'dev'
};
